import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import CommonService from '../../../../services/commonService';

export const AndimarTitle = ({ title }) => {
  const operator = CommonService.getLocal('op');

  return (
    <div className="favorite-destinations-heading d-flex align-center justify-center my-4 less-bold-text">
      <span className="d-inline-block title-dash-line"  style={{background: operator && operator.operator_name == "sanantonio" ? operator && operator.theme_color2 && operator.theme_color2 :''}} ></span>
      <div
        className="px-2 text-uppercase m-0"
        style={{
          color: operator && operator.theme_color2 && operator.operator_name != "sanantonio" ?  operator.theme_color2 :  operator && operator.color_codes && operator.color_codes.sub_footer_color , 
          fontSize: '22px',
          fontWeight: 'bold',
        }}
      >
        {title ? title : 'title here'}
      </div>
      <span className="d-inline-block title-dash-line" style={{background: operator && operator.operator_name == "sanantonio" ? operator && operator.color_codes.theme_color :''}}></span>
    </div>
  );
};

const styles = {
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 20,
    paddingBottom: 20,
  },
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AndimarTitle);



// WEBPACK FOOTER //
// ./src/features/themes/common/Title/AndimarTitle.js